import { el } from '@/lib/dom'
import { webButton } from '@/browser/ui'

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * BRAUZER SKİNİNİN ORTAQ İKONLARI
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * Sahib tələbi (2026-08-22): «veb TV kinobox az -da heroda buttonlar səsi aç tam
 * ekran nədir qoymusan onlar həmişə icon olub axı». Doğrudur — saytda hero-nun
 * səs və tam ekran düymələri MƏTNSİZDİR (`apps/web/src/components/Hero.tsx` →
 * `btn btn--outline btn--lg btn--square`), yalnız işarə + `aria-label`.
 *
 * ⚠ NİYƏ AYRICA FAYL: eyni beş ikon həm film modalında (`detailModal.ts`), həm
 *   hero-da lazımdır. Əvvəl onlar modalın içində sabit idi — hero üçün ikinci
 *   nüsxə çıxarmaq iki yerdə fərqli qalınlıq/ölçü riski deməkdir.
 * ⚠ İkonlar saytdakı ilə eyni cizgidədir: 24×24 baza, `currentColor`, 2.2px
 *   xətt — düymənin rəngini miras alır, yəni tema dəyişsə də ayrıca iş yoxdur.
 */

export const ICON_PLAY =
  '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="none">' +
  '<path d="M8 5v14l11-7z"/></svg>'

export const ICON_CLOSE =
  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
  'stroke-width="2.4" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>'

export const ICON_FULLSCREEN =
  '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
  'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
  '<path d="M3 9V3h6"/><path d="M21 9V3h-6"/><path d="M3 15v6h6"/><path d="M21 15v6h-6"/></svg>'

const SPEAKER = '<path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor" stroke="none"/>'

export const ICON_MUTED =
  '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
  'stroke-width="2.2" stroke-linecap="round">' +
  SPEAKER +
  '<path d="M17 9.5l5 5M22 9.5l-5 5"/></svg>'

export const ICON_SOUND =
  '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
  'stroke-width="2.2" stroke-linecap="round">' +
  SPEAKER +
  '<path d="M17 8.6a5 5 0 0 1 0 6.8"/><path d="M20 5.8a9 9 0 0 1 0 12.4"/></svg>'

/** Dil seçimi — qlobus (saytdakı `LanguageSwitcher` ilə eyni cizgi). */
export const ICON_GLOBE =
  '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
  'stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M3.2 9h17.6M3.2 15h17.6"/>' +
  '<path d="M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18"/></svg>'

/** Açılan siyahının oxu. */
export const ICON_CARET =
  '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
  'stroke-width="3"><path d="M6 9l6 6 6-6"/></svg>'

/** Seçili bəndin onay işarəsi. */
export const ICON_CHECK =
  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
  'stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m5 13 4 4 10-10"/></svg>'

/** İkonu düymənin içində mərkəzə oturdan qutu. */
export function iconBox(svg: string): HTMLElement {
  const box = el('span', 'web-iconbox')
  // ⚠ `innerHTML` YALNIZ SABİT sətirlə və yalnız qurulma anında — istifadəçi
  //   datası bu yola HEÇ VAXT düşmür (`app.ts`-dəki rail ikonları ilə eyni qayda).
  box.innerHTML = svg
  return box
}

/** Yalnız-ikon düymə — etiket ekran oxuyucusu üçün `aria-label`-dədir. */
export function iconButton(svg: string, label: string, run: () => void): HTMLButtonElement {
  const node = webButton('', run, true)
  node.className += ' web-btn--icon'
  node.setAttribute('aria-label', label)
  node.title = label
  if (svg) node.appendChild(iconBox(svg))
  return node
}
